import styled from "styled-components";

import { DESKTOP_BREAKPOINT } from "../../../../../components/AppShell/styles";
import { FormGroup } from "../../../../../components/Form/styles";

const MOBILE = `not all and (min-width: ${DESKTOP_BREAKPOINT})`;

/* Shared layout of the form storage screens (e-mail, Mailchimp), same as the tracking integrations */

export const Container = styled.div`
  padding-bottom: 2rem;
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 1.5rem 2rem 0;

  @media ${MOBILE} {
    padding: 20px 20px 0;
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 20px;
  background: var(--color-neutral-dark);
  border-radius: 1rem;

  /* The card's gap already spaces the fields */
  ${FormGroup} {
    margin-bottom: 0;
  }

  .lead {
    font-size: 0.875rem;
    line-height: 1.25rem;
    color: var(--color-neutral-150);
  }
`;

/* Discard/save (or connect) for the card above, right-aligned at its bottom */
export const CardFooter = styled.div`
  display: flex;
  gap: 1.25rem;
  align-items: center;
  justify-content: flex-end;
  padding-top: 1rem;
  border-top: 1px solid var(--color-neutral-base);
`;

export const RemoveLink = styled.button`
  align-self: flex-start;
  margin: 2rem 2rem 0;
  font-family: Inter, sans-serif;
  font-size: 0.875rem;
  font-weight: 700;
  color: var(--color-feedback-danger);

  &:hover {
    text-decoration: underline;
  }

  @media ${MOBILE} {
    margin: 1.5rem 20px 0;
  }
`;
